import { JSX } from 'react';
import { useTranslation } from 'react-i18next';
import { useLayout } from '../hooks/layout.hook';

export function PrivacyScreen(): JSX.Element {
  const { t } = useTranslation();

  useLayout(
    () => ({
      hideFooter: true,
      backButton: true,
      title: t('Legal terms'),
    }),
    [t],
  );

  return (
    <ul className="list bg-base-100 rounded-box shadow-md">
      {sections.map((s, i) => (
        <li key={s.title} className="list-row flex flex-col">
          <div className="font-bold text-lg">
            {i + 1}. {s.title}
          </div>
          <div className="font-normal text-base-content/70">{s.content}</div>
        </li>
      ))}
    </ul>
  );
}

const sections = [
  {
    title: 'Einleitung',
    content:
      "Der Schutz Ihrer persönlichen Daten ist uns ein wichtiges Anliegen. Diese Datenschutzerklärung informiert Sie darüber, wie wir Ihre Daten im Rahmen der Nutzung der App 'Virtus' erheben, verarbeiten und schützen.",
  },
  {
    title: 'Verantwortlicher',
    content: (
      <>
        Verantwortlicher für die Datenverarbeitung ist der Verein Katholische Jugendbewegung Schweiz. Bei Fragen oder
        Anliegen können Sie uns unter folgender E-Mail-Adresse kontaktieren:{' '}
        <a className="link link-accent" href="mailto:virtus@kjb.ch">
          virtus(at)kjb.ch
        </a>
      </>
    ),
  },
  {
    title: 'Erhebung und Verarbeitung von Daten',
    content:
      "Die App 'Virtus' erhebt und verarbeitet persönliche Daten, die Sie uns zur Verfügung stellen. Die von uns beauftragten Entwickler haben Zugriff auf diese Daten, jedoch werden sie nicht eingesehen, verwendet oder an Dritte weitergegeben. Ihre Daten bleiben vertraulich und werden ausschließlich für die Funktionalität der App benötigt.",
  },
  {
    title: 'Speicherung der Daten',
    content: (
      <>
        Die von uns erhobenen Daten werden in der Cloud-Datenbank Google Firestore gespeichert. Firestore ist ein Dienst
        von Google, und Ihre Daten können im Rahmen dieses Services von Google verarbeitet werden. Weitere Informationen
        zur Datenverarbeitung durch Google finden Sie in der{' '}
        <a className="link link-accent" target="_blank" href="https://policies.google.com/privacy">
          Google Datenschutzrichtlinie
        </a>
        .
      </>
    ),
  },
  {
    title: 'Datensicherheit',
    content:
      'Wir gewährleisten die Datensicherheit durch mehrere Schutzmaßnahmen. Firestore verschlüsselt alle Daten sowohl während der Übertragung als auch im Ruhezustand mit branchenüblichen Verschlüsselungsverfahren. Wir verwenden Firebase Authentication zur Verifizierung der Benutzeridentitäten und definieren strikte Firestore-Sicherheitsregeln, um den Zugriff basierend auf der Authentifizierung zu beschränken. Darüber hinaus läuft Firestore auf der Google Cloud Plattform, die den besten Praktiken der Branche folgt und die Anforderungen der DSGVO, ISO 27001 und SOC 2 Standards erfüllt.',
  },
  {
    title: 'Haftungsausschluss',
    content:
      "Die Betreiber der App 'Virtus' übernehmen keine Haftung für Schäden, die aus der Nutzung oder der Unmöglichkeit der Nutzung der App entstehen. Dies gilt insbesondere für Schäden, die durch den Verlust von Daten oder durch unbefugten Zugriff auf Ihre Daten entstehen könnten.",
  },
  {
    title: 'Ihre Rechte',
    content:
      'Sie haben das Recht, Auskunft über die von uns über Sie gespeicherten Daten zu verlangen, diese zu berichtigen oder zu löschen.',
  },
  {
    title: 'Änderungen der Datenschutzerklärung',
    content:
      'Wir behalten uns das Recht vor, diese Datenschutzerklärung jederzeit zu ändern. Die jeweils aktuelle Version wird in der App veröffentlicht.',
  },
  {
    title: 'Rechtsgrundlagen',
    content: (
      <>
        Die Verarbeitung Ihrer Daten erfolgt auf Grundlage der folgenden gesetzlichen Bestimmungen:
        <ul className="list-disc ml-5">
          <li>
            EU-Datenschutz-Grundverordnung (DSGVO), Artikel 6 (Rechtsgrundlagen für die Verarbeitung personenbezogener
            Daten)
          </li>
          <li>Schweizer Datenschutzgesetz (DSG), Artikel 4 (Rechtmäßigkeit der Datenbearbeitung)</li>
        </ul>
        <br />
        Diese Datenschutzerklärung tritt mit der Nutzung der App 'Virtus' in Kraft. Vielen Dank für Ihr Vertrauen!
      </>
    ),
  },
];
